module.exports = "/_next/static/resources/ingredients-fa6c40fb6de9411eda919211521e7955.png";